export default __webpack_public_path__ + "static/media/hassan2.ecf00253.jpg";